import { Type } from '@angular/core';
import { AbstractBannerPlaceService } from '@web-bankir/shared/components/banner/abstractions';
import { BannerPlace } from "./banner-place.const";

export const BANNER_PLACE_MAP: Map<BannerPlace, () => Promise<Type<AbstractBannerPlaceService>>> = new Map([
  [
    BannerPlace.HeaderNotification,
    (() => import('../header-notification-banners.service').then((file) => file.HeaderNotificationBannersService))
  ],
])
